import { useEffect, useState } from 'react';
import { momentOf, type Moment } from '@/domain/records/worklog';

/**
 * «Bây giờ» tự cập nhật — cho đồng hồ đếm ngược và tiêu đề có ngày. Chỉ đổi giá trị khi PHÚT đổi,
 * nên component dùng nó không vẽ lại vô ích giữa hai mốc phút.
 */
export function useNow(intervalMs = 20_000): Moment {
  const [now, setNow] = useState(() => momentOf());
  useEffect(() => {
    const timer = window.setInterval(() => {
      const next = momentOf();
      setNow((current) =>
        current.minutes === next.minutes && current.date.day === next.date.day ? current : next,
      );
    }, intervalMs);
    return () => window.clearInterval(timer);
  }, [intervalMs]);
  return now;
}
